import Cookies from 'js-cookie';
import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

function Navbar() {
  const navigate = useNavigate();
  let user = '';
  if (Cookies.get('user')) {
    user = JSON.parse(Cookies.get('user'));
  }

  function logouthandler() {
    const confirmation = window.confirm('Yakin ingin logout?');
    if (confirmation) {
      Cookies.remove('token');
      Cookies.remove('user');
      window.alert('Logout berhasil!');
      navigate('/login');
    }
  }
  return (
    <div className="topnav">
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <a
            className="navhome text-dark ms-5 fs-2 fw-bold text-decoration-none"
            href="#"
          >
            Job <span className="part-title">Vacancy</span>
          </a>
          <div>
            <div className="d-flex align-items-center ms-auto gap-5">
              <Link to="/" className="text-decoration-none ">
                <button className="navhome btn">Home</button>
              </Link>
              {!Cookies.get('token') && (
                <Link className="p-2 text-decoration-none" to="/login">
                  <button className="navhome btn">Login</button>
                </Link>
              )}

              {Cookies.get('token') && (
                <>
                  <button
                    className="navhome navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbar-list-4"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>
                  <div className="collapse navbar-collapse" id="navbar-list-4">
                    <div className="dropstart">
                      <img
                        className="dropdown-toggle profile-nav me-5"
                        style={{ width: '60px' }}
                        data-toggle="dropdown"
                        href="#"
                        src={user.image_url}
                      />
                      <ul
                        style={{ width: '50px' }}
                        className="dropdown-menu dropdown-menu-start position-relative"
                        role="menu"
                        aria-labelledby="dLabel"
                      >
                        <li className="dropdown-item text-center fs-4">
                          {user.name}
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/dashboard">
                            <button className="navhome btn">Dashboard</button>
                          </Link>
                        </li>
                        <li>
                          <hr className="dropdown-divider" />
                        </li>

                        <li className="">
                          <button
                            className="navhome btn d-inline dropdown-item"
                            onClick={logouthandler}
                          >
                            Logout
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
